import type { ComponentProps, ComponentPropsWithoutRef } from "react";
import { Button as CoreButton } from "@workspace/blocks/ui";

type Variant = "primary" | "secondary" | "ghost" | "destructive";
type Size = "default" | "sm" | "lg" | "icon";
const variants = { primary: "default", secondary: "outline", ghost: "ghost", destructive: "destructive" } as const;
type ButtonProps = ComponentProps<"button"> & { variant?: Variant; size?: Size };
type ButtonLinkProps = ComponentPropsWithoutRef<"a"> & { variant?: Variant; size?: Size };

export function Button({ variant = "primary", size = "default", type = "button", ...props }: ButtonProps) {
	return <CoreButton variant={variants[variant]} size={size} type={type} {...props} />;
}
export function ButtonLink({ variant = "primary", size = "default", children, ...props }: ButtonLinkProps) {
	return (
		<CoreButton variant={variants[variant]} size={size} asChild>
			<a {...props}>{children}</a>
		</CoreButton>
	);
}
